import * as React from 'react';
const SvgDiagonal = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 10, height: 24, fill: "none" }, props),
    React.createElement("path", { stroke: "#CACACA", d: "M9.209.724 1 23.276" })));
export default SvgDiagonal;
